var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandartBooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m33.598 71.165 33.363 4.606L89.338 94.5 10 79.715l23.598-8.55Z",
    fill: "#FFC239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.338 94.5 93 29.763l-26.04-4.886v50.894L89.339 94.5Z",
    fill: "#FFC239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m33.598 71.165 33.363 4.606V24.877l-33.363-6.641v52.93ZM10 79.715l23.598-8.55v-52.93L10 12.664v67.052Z",
    fill: "#FFC239"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.598 71.165 10 79.715m23.598-8.55 33.363 4.606m-33.363-4.606v-52.93M10 79.716V12.663m0 67.052L89.338 94.5M10 12.663 36.04 10.5l30.92 5.293L93 29.763m-83-17.1 23.598 5.573M93 29.763 89.338 94.5M93 29.763l-26.04-4.886M89.339 94.5 66.961 75.771m0 0V24.877m0 0-33.363-6.641",
    stroke: "#0D0D0D",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandartBooth);
export default __webpack_public_path__ + "static/media/standart-booth.b4a4b9631349340e68787bbcf682d0b5.svg";
export { ForwardRef as ReactComponent };